<div class="chat-wrapper">
  <!-- Sidebar utenti -->
  <div class="user-list">
    <h3>Persone</h3>
    <ul>
      <li *ngFor="let persona of persone"
          (click)="selectPersona(persona)"
          [class.selected]="persona === selectedPersona">
        {{ persona.Nome }} {{ persona.Cognome }} ({{getNumeromessagginonletti(persona.Codice)}})
      </li>
    </ul>
  </div>

  <!-- Area chat -->
  <div class="chat-container" *ngIf="selectedPersona">
    <h4>Chat con {{ selectedPersona.Nome }} {{ selectedPersona.Cognome }}</h4>
    
    <div class="messages">
      <div *ngFor="let message of messages" [ngClass]="message.Stile">
        <span>{{ message.Testo }}</span>
        <div class="timestamp">{{ message.Data | date:'shortTime' }}</div>
      </div>
      <div #messagesEnd></div> <!-- Punto di riferimento per l'autoscroll -->
    </div>

    <div class="input-area">
      <input [(ngModel)]="newMessage" (keyup.enter)="sendMessage()" placeholder="Scrivi un messaggio..." />
      <button (click)="sendMessage()">Invia</button>
    </div>
  </div>

  <!-- Placeholder se nessun utente è selezionato -->
  <div class="chat-container" *ngIf="!selectedPersona">
    <p>Seleziona un utente per iniziare la chat.</p>
  </div>
</div>
